import { all, call, put, select, take, takeEvery } from 'redux-saga/effects';
import { postJSON, getJSON } from '../util';

export function* purchaseCoins() {
    const user = yield select(state => state.user);
    const upc = yield select(state => state['karmacoin-store'].upc);

    yield put({
        type: 'product:update',
        payload: {
            type: 'Karma Coins',
        },
    });

    if (!user.logged_in) {
        yield all([
            put({
                type: 'route:to',
                payload: 'login',
            }),
            take('user:logged-in'),
        ]);
    }

    yield put({
        type: 'product:update',
        payload: {
            submitting: true,
        },
    });

    try {
        const response = yield call(postJSON, `/api/product/submit/${upc}`);

        yield put({
            type: 'location:href',
            payload: response.forwarding_url,
        });
    } catch (e) {
        yield put({
            type: 'product:update',
            payload:  {
                error: e,
                submitting: false,
            },
        });
    }
}

export function* getKarmaCoinPackages() {
    const packages = yield call(getJSON, '/api/product/karmacoin-packages');
    const user = yield select(state => state.user);
    const standard_packages_min_coins = 50;
    const power_packages_min_coins = 2000;

    if (user.logged_in && packages[0].voucher_upc) {
        yield call(getCustomMessage, packages, 'text-teeup-message');
    }

    const kcpackages = packages.reduce((kcpackages, pkg) => {
        let kcs = pkg.free_kcs + pkg.paid_kcs;
        let percent = 0;

        if (pkg.label && pkg.label.match(/[0-9]+%/)) {
            percent = pkg.label.match(/[0-9]+%/)[0];
        }

        pkg.percent = percent;

        if (kcs >= power_packages_min_coins) {
            kcpackages.power.push(pkg);
        } else if (kcs > standard_packages_min_coins) {
            kcpackages.standard.push(pkg);
        }

        return kcpackages;
    }, {power: [], standard: []});

    yield put({
        type: 'karmacoin-store:update',
        payload: {
            packages: {
                power: kcpackages.power,
                standard: kcpackages.standard.reverse(),
            },
        },
    });
}

function* getCustomMessage(packages, placement) {
    const [api, params] = yield all([
        select(state => state.api.host),
        select(state => state.api.params),
    ]);
    if (packages[0].voucher_upc) {
        let vparams = { partner: params.partner, key: params.key };
        vparams.voucher__upc = packages[0].voucher_upc;
        vparams.site = params.partner;
        vparams.placement = placement;
        const url = `${api}/rules/voucher-ownership/promo`;
        const promo = yield call(getJSON, url, vparams);
        if (promo && promo.length > 0) {
            for (let p in packages) {
                packages[p].message = promo[0].message;
            }
        }
    }
}

export function* root() {
    const should_run = yield select(state => state['karmacoin-store'] && state['karmacoin-store'].upc);
    if (!should_run) {
        return;
    }

    yield call(getKarmaCoinPackages);

    yield all([
        takeEvery(['user:logged-in', 'user:logged-out'], getKarmaCoinPackages),
        takeEvery('karmacoin-store:purchase', purchaseCoins),
    ]);
}
